export const WYSWIG_EDITOR_CONFIG = {
  editable: true,
  spellcheck: true,
  height: '15rem',
  minHeight: '5rem',
  placeholder: 'Enter text here...',
  translate: 'no',
  defaultParagraphSeparator: '',
  defaultFontName: 'Arial',
  toolbarHiddenButtons: [
    ['strikeThrough'],
    [
      'textColor',
      'backgroundColor',
      'customClasses',
      'unlink',
      'insertVideo',
      'insertHorizontalRule',
      'removeFormat',
      'toggleEditorMode',
    ],
  ],
  enableToolbar: true,
  showToolbar: true
};

export const ELEMENTS_LIST = [
  {
    img: 'assets/img/text-fiels.png',
    type: 'text',
    tootipText: 'Text',
    subType: 'text',
    userHelperContext:
      'Drag and drop the component in the assembly section to create a short and general text input',
  },
  {
    img: 'assets/img/text-area-field.png',
    type: 'textarea',
    tootipText: 'Textarea',
    userHelperContext:
      'Drag and drop the component in the assembly section to create a multi-line input field that allows for longer text input',
  },
  {
    img: 'assets/img/text-box.png',
    type: 'textbox',
    tootipText: 'Textbox',
    userHelperContext:
      'Drag and drop the component in the assembly section to create a WYSIWYG text box',
  },
  {
    img: 'assets/img/dropdown-field.png',
    type: 'dropdown',
    tootipText: 'Dropdown',
    userHelperContext:
      'Drag and drop the component in the assembly section to create a list of values in a dropdown list where users can select one of the values',
  },
  {
    img: 'assets/img/dropdown-field.png',
    type: 'multiselect-dropdown',
    tootipText: 'Multiselect Dropdown',
    userHelperContext:
      'Drag and drop the component in the assembly section to create a list of values in a dropdown list where users can select multiple values',
  },
  {
    img: 'assets/img/radio-field.png',
    type: 'radio',
    tootipText: 'Radio',
    userHelperContext:
      'Drag and drop the component in the assembly section to create a field that allows users to select a single option from a list of options displayed in radio-style format',
  },
  {
    img: 'assets/img/checkbox-field.png',
    type: 'checkbox',
    tootipText: 'Checkbox',
    userHelperContext:
      'Drag and drop the component in the assembly section to create a multi-valued component that allows users to select one or more options in checkbox style format',
  },
  {
    img: 'assets/img/date-field.png',
    type: 'date',
    tootipText: 'Date',
    userHelperContext:
      'Drag and drop the component in the assembly section to create a component that allows users to choose date',
  },
  {
    img: 'assets/img/signpost.png',
    type: 'guidance',
    tootipText: 'Guidance',
    userHelperContext:
      'Drag and drop the component in the assembly section to create a ',
  },
  // Attachment element is made dormant temporarily
  { img: 'assets/img/code-field.png', type: 'file', tootipText: 'Attachment', subType: '', userHelperContext: 'Drag and drop the component in the assembly section to create a component that allows users to attach files to a form' },
  // { img: 'assets/img/code-field.png', type: 'text', tootipText: 'Executive Compensation', subType: 'shortText' },
  // { img: 'assets/img/code-field.png', type: 'text', tootipText: 'NAICS Code', subType: 'shortText' }
  {
    img: 'assets/img/signpost.png',
    type: 'Submitter',
    tootipText: 'Submitter',
    userHelperContext:
      'Drag and drop the component in the assembly section to create a ',
  },
];

export const MASTER_DATA_FIELDS_LIST = [
  { fieldname: 'Organisation Name', FieldID: 111 },
  { fieldname: 'Organisation Tax ID', FieldID: 112 },
  { fieldname: 'Organisation DUNS Number', FieldID: 113 },
  { fieldname: 'Organisation Address 1', FieldID: 114 },
  { fieldname: 'Organisation Address 2', FieldID: 115 },
  { fieldname: 'Organisation City', FieldID: 116 },
  { fieldname: 'Organisation Country', FieldID: 117 },
  { fieldname: 'Organisation State', FieldID: 118 },
  { fieldname: 'Organisation Zip Code', FieldID: 119 },
  { fieldname: 'Organisation Contact Person First Name', FieldID: 120 },
  { fieldname: 'Organisation Contact Person Last Name', FieldID: 121 },
  { fieldname: 'Organisation Contact Person Phone Number', FieldID: 122 },
  { fieldname: 'Organisation Contact Person Email', FieldID: 123 },
  { fieldname: 'Organisation Contact Person Address 1', FieldID: 124 },
  { fieldname: 'Organisation Contact Person Address 2', FieldID: 125 },
  { fieldname: 'Organisation Contact Person City', FieldID: 126 },
  { fieldname: 'Organisation Contact Person State', FieldID: 127 },
  { fieldname: 'Organisation Contact Person Zip', FieldID: 128 },
  { fieldname: 'Organisation Contact Person Country', FieldID: 129 },
  { fieldname: 'NAICS Code', FieldID: 130 },
  { fieldname: 'Ownership/Diversity', FieldID: 131 },
  { fieldname: 'Business Type', FieldID: 132 },
  {
    fieldname:
      'Are you International Standards Organisation(ISO) 9000 Certified?',
    FieldID: 133,
  },
  {
    fieldname: 'Are you Aerospace Standards (AS) 9100 Certified?',
    FieldID: 134,
  },
  {
    fieldname: 'Are you Aerospace Standards (AS) 9120 Certified?',
    FieldID: 135,
  },
  {
    fieldname: 'Are you Capability Maturity Model Integration(CMMI) Certified?',
    FieldID: 136,
  },
  { fieldname: 'If Yes,What Level?', FieldID: 137 },
  { fieldname: 'Is your company owned by a parent company', FieldID: 138 },
  { fieldname: 'Parent Company Name', FieldID: 139 },
];
